import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { AppPage } from '../../components/general';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AppPage title="Unauthorized Access" breadcrumbs="Error - Unauthorized">
      <div className="grid gap-5">
        <div className="col-12">
          <div className="card">
            <div className="flex flex-column align-items-center p-5">
              <i className="pi pi-lock text-6xl text-red-500 mb-4"></i>
              <h2>401 - Unauthorized Access</h2>
              <p className="text-lg my-3">
                You don't have permission to access this page. Please contact your administrator if you believe this is a
                mistake.
              </p>
              <div className="flex gap-3 mt-4">
                <Button label="Go to Dashboard" icon="pi pi-home" onClick={() => navigate('/dashboard')} />
                <Button
                  label="Go Back"
                  icon="pi pi-arrow-left"
                  className="p-button-secondary"
                  onClick={() => navigate(-1)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppPage>
  );
};

export default Unauthorized;
